import { render, staticRenderFns } from "./EnforcementList.vue?vue&type=template&id=2e5f93f2"
import script from "./EnforcementList.vue?vue&type=script&lang=js"
export * from "./EnforcementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports